export default __webpack_public_path__ + "images/roi-stack.jpg";